import React from "react";
interface iLoading {
  w:string;
  h:string;
  className?:string;
}

const Loading: React.FC<iLoading> = ({ w, h, className=""}) => {
  const hasPadding = /\b(p|px|py|pl|pr|pt|pb)-\d+\b/.test(className) || /\bp-\[.*?\]\b/.test(className);

  return (
    <div className={`flex justify-start items-center space-x-1 ${ hasPadding ? "" : "p-3"} ${className}`}>
      <div className={`${w} ${h} bg-blue-500 rounded-full animate-[typing-bubble_1.2s_ease-in-out_infinite]`}></div>
      <div className={`${w} ${h} bg-blue-500 rounded-full animate-[typing-bubble_1.2s_ease-in-out_infinite_0.2s]`}></div>
      <div className={`${w} ${h} bg-blue-500 rounded-full animate-[typing-bubble_1.2s_ease-in-out_infinite_0.4s]`}></div>
    </div> 
  );
};

export default Loading;
